import { Injectable } from '@angular/core';
import { LU_GridModelServiceBase } from 'scaletech-tickets';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class LU_GridService extends LU_GridModelServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
